import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Close } from "@mui/icons-material";

export default function Modal ({ title, open, close, children}){
    return(
        <Dialog open={open} onClose={close}>
            <DialogTitle>
                {title}
                <IconButton
                    aria-label="close"
                    onClick={close}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: grey[500]
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
        </Dialog>
    )
}